import {Text} from '@dropbox/dig-components/typography';
import {atoms} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {OutOfOfficeLine} from '@dropbox/dig-icons/assets';
import {NotificationCard} from 'components/notifications/NotificationCard';
import {useNotificationContext} from 'components/notifications/utils/useNotificationContext';
import {format, parseISO} from 'date-fns';
import {t} from 'i18next';
import {Trans} from 'react-i18next';

type SubscribedOooData = {
  target_ldap?: string;
  target_name?: string;
  start_date?: string;
  end_date?: string;
};

export const SubscribedOoo = () => {
  const {
    archiveable,
    upcoming,
    notification: {archived, data: notification},
  } = useNotificationContext();
  const {to, cta} = notification;
  const data = parseSubscribedOooData(notification.data);
  const targetName = data?.target_name ?? notification.data;

  return (
    <NotificationCard
      accessory={<UIIcon src={OutOfOfficeLine} className={atoms({color: 'Text Subtle'})} />}
      header={
        <Trans
          i18nKey="notification_ooo"
          t={t}
          values={{data: targetName}}
          components={{b: <Text isBold />}}
        />
      }
      subtext={formatOooRange(data)}
      to={to}
      archived={archived}
      buttonLink={!archived && !archiveable && !upcoming ? {to, cta} : undefined}
    />
  );
};

const parseSubscribedOooData = (rawData: string): SubscribedOooData | null => {
  try {
    const parsed = JSON.parse(rawData);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
};

const formatOooRange = (data: SubscribedOooData | null) => {
  if (!data?.start_date) {
    return '';
  }

  const startDate = format(parseISO(data.start_date), 'EEE, MMM d');
  if (!data.end_date || data.end_date === data.start_date) {
    return startDate;
  }

  return `${startDate} - ${format(parseISO(data.end_date), 'EEE, MMM d')}`;
};
